<template>
      <div id="plan-options-current">
            <section class="section intro-hero animate__animated animate__fadeIn">
                  <BackButton link="/one-more-question-current" />
                  <div class="grid-container max">
                        <div class="intro-hero-grid">
                              <div class="intro-hero-left">
                                    <h1>Your Anthem<br />plan options<br />for 2027</h1>
                              </div>
                              <div class="intro-hero-right">
                                    <p class="plan-select-label">Select your plan option and tier:</p>
                                    <div class="plan-tiles">
                                          <button type="button" class="plan-tile" :class="{ active: activePlan == 'HMO' }" @click="planSelect('HMO')">HMO</button>
                                          <button type="button" class="plan-tile" :class="{ active: activePlan == 'HRA Gold' }" @click="planSelect('HRA Gold')">HRA<br />Gold</button>
                                          <button type="button" class="plan-tile" :class="{ active: activePlan == 'HRA Silver' }" @click="planSelect('HRA Silver')">HRA<br />Silver</button>
                                          <button type="button" class="plan-tile" :class="{ active: activePlan == 'HRA Bronze' }" @click="planSelect('HRA Bronze')">HRA<br />Bronze</button>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <div class="intro-hero-btn-wrap">
                        <button class="intro-hero-btn" @click="storeData()"><span>Next</span></button>
                  </div>
            </section>
      </div>
</template>

<script>
import BackButton from "../components/BackButton"
import gaEventMixin from "../mixins/gaEventMixin"
export default {
      name: "SHBPPlanOptionsCurrent",
      data() {
            return {
                  activePlan: this.$store.state.planSelect,
            }
      },
      methods: {
            planSelect(name) {
                  this.$store.commit("changePlan", name)
                  this.track("Choice", name + " Coverage")
                  this.activePlan = name
                  localStorage.setItem("antPlan", name)
            },
            storeData() {
                  let planSelected = this.$store.state.planSelect
                  let message = "Sorry, but you must select a plan before proceeding to the next step."
                  if (!planSelected) {
                        this.$swal({
                              html: message,
                              showCancelButton: false
                        })
                  }
                  else {
                        this.$router.push("/summary-options-current")
                  }
            }
      },
      mounted() {
            window.scrollTo(0, 0)
      },
      components: { BackButton },
      mixins: [gaEventMixin]
}
</script>

<style lang="scss">
#plan-options-current {
      .intro-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 100px 0;
            position: relative;
            min-height: calc(100vh - 68px);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .intro-hero-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: space-between;
                  gap: 40px;
            }

            .intro-hero-left {
                  flex: 1 1 480px;
                  max-width: 640px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(4.25rem, 6.5vw, 5.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }
            }

            .intro-hero-right {
                  flex: 1 1 320px;
                  max-width: 400px;

                  .plan-select-label {
                        color: #012E58;
                        font-size: 1rem;
                        font-weight: 600;
                        margin-bottom: 20px;
                  }

                  .plan-tiles {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        gap: 16px;
                  }

                  .plan-tile {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        aspect-ratio: 1 / 1;
                        background-color: #1355E9;
                        color: #ffffff;
                        font-size: 1.375rem;
                        font-weight: 600;
                        line-height: 1.3;
                        border: none;
                        border-radius: 4px;
                        cursor: pointer;
                        transition: background-color 0.2s ease-in-out;

                        &:hover,
                        &.active {
                              background-color: #012E58;
                        }
                  }
            }

            .intro-hero-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .intro-hero-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 100px 24px;
                  justify-content: flex-start;

                  .back-btn {
                        left: 2rem;
                  }

                  .intro-hero-grid {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0;
                  }

                  .intro-hero-left {
                        flex: 0 0 auto;
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 11vw, 5.25rem) !important;
                        }
                  }

                  .intro-hero-right {
                        flex: 0 0 auto;
                        width: 100%;
                        max-width: 320px;
                        margin-top: 48px;
                  }
            }
      }
}
</style>
